import React from 'react'
import { useSpring, animated } from 'react-spring'
import { Link } from 'react-router-dom';
import { RedirectToHome } from '../config';

const Main = ({ children, className }) => {

  return (
    <div className={`flex shadow-2  flex-column flex-grow-1  align-items-center  h-screen surface-800 text-white overflow-hidden ${className}` } >
      <Link  onClick ={ RedirectToHome }  style={{height: '2.3rem'}} className="text-center mt-3 text-white border-white border-solid border-circle	w-2rem border-1">
        <svg style={{marginTop:'.3rem'}} stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" className="fill-current d-inline-block" height="18px" width="18px" xmlns="http://www.w3.org/2000/svg"><path d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"></path></svg>

      </Link>
     {children}
    </div>
  )
}

const SideDraw = ({ children }) => {
  const [toggle] =  true//useRecoilState(notifications)

  const _sideNav = useSpring({
    marginLeft: toggle ? -1 : -256
  })

  return (
    <animated.div style={_sideNav} className="h-screen w-64 bg-gray-800 text-white relative border-r border-gray-900">
      <InfomationButton />
      {children}
    </animated.div>
  )
}

const Nav = ({ children , className}) => {
  // const [page] =0// useRecoilState(navigation)
  // let page =0;
  // const mt = (4 * page) + (1 + page);
  // let _activeLink = useSpring({ marginTop: `${mt}rem` })

  return (
    <nav className={`relative h-full flex flex-column w-full ${className}`}>
      {children}
    </nav>
  )
}

const Button = ({ children, profileIndex }) => {

  // const [profile, setProfile] = useRecoilState(notifications)

  return (
    <button
      // onClick={() => setProfile(profile === profileIndex ? 0 : profileIndex)}
      className="w-16 h-16 flex justify-center focus:outline-none relative">
      <div className="z-40">
        {children}
      </div>
      {/* <div className="bg-red-700 h-4 rounded text-white text-xs pt-0 px-2 bottom-0 mb-4 mr-2 right-0 leading-snug absolute z-50">0</div> */}
    </button >
  )
}

const NavLink = ({ icon, title,  to, active }) => {
  let classClass = active ? 'bg-white border-1   text-color' :'';
  return (
    <Link to={to}  className ={`flex pt-2 pb-2 flex-column justify-content-center align-content-center align-items-center text-white ${classClass}`}>
       <i className= { icon} />
       <div className="text-xs m-1"> { title } </div>
    </Link>
  )
}

const Notifications = (props) => (<div {...props} className="bg-gray-800 h-full"> {props.children} </div>)
const Profile = ({ children }) => (<div className="surface-900 w-full"> {children} </div>)
const User = ({ children }) =>( <div className="flex justify-content-center align-items-center p-2 surface-900"> {children} </div> )
const Sidebar = ({ children }) => ( <section className="flex relative h-screen"> {children} </section> )


const InfomationButton = () => {
  const _colorPrimary =  'red'//getCSSvariable("--color-primary")
  const _colorGray900 = 'green'//getCSSvariable("--gray-900")
  const _colorGray500 ='blue'// getCSSvariable("--gray-500")
  // setToggle(toggle === 3 ? 0 : 3)}
  // const [toggle, setToggle] = useRecoilState(notifications)
  const toggle = true;
  const _btn = useSpring({
    backgroundColor: toggle
     ? _colorGray500 : _colorPrimary,
    border: toggle ? `1px solid ${_colorGray900}` : `1px solid transparent`
  })

  const handleClick = () => {
    if (toggle) {
      // setToggle(0)
      return true
    }
  }

  return (
    <animated.button
      onClick={handleClick}
      style={_btn}
      className="focus:outline-none rounded-full bg-primary shadow h-8 w-8 -mr-4 mt-8 right-0 flex flex-col justify-center items-center absolute z-50">
      {toggle ? <>r</>: <></>
        // <RiCloseCircleLine className="fill-current" size="20px" /> :
        // <BsInfoCircle className="fill-current" size="20px" />
      }
    </animated.button>
  )
}


Sidebar.Nav = Nav
Sidebar.Main = Main
Sidebar.SideDraw = SideDraw
Sidebar.NavLink = NavLink
Sidebar.Profile = Profile
Sidebar.User = User
Sidebar.Notifications = Notifications
Sidebar.Button = Button

export default Sidebar;
